import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=3e8e6d77&scoped=true&"
import script from "./SubmitOrder.vue?vue&type=script&lang=js&"
export * from "./SubmitOrder.vue?vue&type=script&lang=js&"
import style0 from "./SubmitOrder.vue?vue&type=style&index=0&id=3e8e6d77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e6d77",
  null
  
)

export default component.exports